module.exports = __webpack_public_path__ + "img/timer_off_24px.c37c3205.svg";